import { StatusFormatterVariant } from '@components'

import { formatDate } from '../../../../../../../utils'
import { SyncStatus } from '../enums/syncStatus'

interface SyncStatusVariant {
  variant: StatusFormatterVariant
  label: string | ((syncDate?: string, locale?: string) => string)
}

export const accountSyncStatusToVariant: Record<SyncStatus, SyncStatusVariant> = {
  [SyncStatus.Synced]: {
    variant: 'success',
    label: (syncDate?: string, locale?: string) => (syncDate ? formatDate(syncDate, 'd MMM yyyy, HH:mm', locale) : ''),
  },
  [SyncStatus.Realtime]: {
    variant: 'success',
    label: 'bank.accounts.list.card.sync_status.realtime',
  },
  [SyncStatus.Closed]: {
    variant: 'error',
    label: 'bank.accounts.list.card.sync_status.closed',
  },
  [SyncStatus.NeedsRenewal]: {
    variant: 'warning',
    label: 'bank.accounts.list.card.sync_status.renew',
  },
  [SyncStatus.ConnectionDeleted]: {
    variant: 'neutral',
    label: 'bank.accounts.list.card.sync_status.connection_deleted',
  },
  [SyncStatus.OfflineData]: {
    variant: 'neutral',
    label: 'bank.accounts.list.card.sync_status.offline_data',
  },
}
